import { useQuery } from "@tanstack/react-query";
import { getPaymentRetrialUrl } from "src/api/services/payment/paymentRetrialService";
import { useAuthContext } from "src/context/AuthContext";

export const usePaymentRetrialQuery = () => {
  const { getValidToken } = useAuthContext();

  const {
    data,
    isLoading: isPaymentRetrialLoading,
    isError: isPaymentRetrialError,
  } = useQuery({
    queryKey: ["getPaymentRetrialUrl"],
    queryFn: async () => {
      const token = await getValidToken();
      if (!token) throw new Error("Missing JWT token");

      const headers = { Authorization: `Bearer ${token}` };
      return getPaymentRetrialUrl(headers);
    },
  });

  return {
    paymentRetrialURL: data?.redirect_uri,
    isPaymentRetrialLoading,
    isPaymentRetrialError,
  };
};
